function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.293 15.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414z",
  fill: "#136BF5"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 2a8.5 8.5 0 100-17 8.5 8.5 0 000 17z",
  fill: "#136BF5"
})));